import React from "react";

export default function ProductDetailModal({ product, onClose }) {
  if (!product) return null;

  return (
    <div className="product-detail-overlay" onClick={onClose}>
      <div
        className="product-detail-modal"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Kapat Butonu */}
        <button className="detail-close-btn" onClick={onClose}>
          ✕
        </button>

        {/* Ürün Görseli */}
        <div className="detail-image-box">
          <img src={product.image} alt={product.title} />
        </div>

        {/* Okunabilir Net Arka Planlı İçerik Kutusu */}
        <div className="detail-content-box">
          <span className="detail-category-badge">Ürün Detayı</span>
          <h2 className="detail-title">{product.title}</h2>

          <div className="detail-divider"></div>

          <p className="detail-description">{product.description}</p>

          {/* Fiyat Bilgileri */}
          <div className="detail-price-card-group">
            {product.portionPrice && (
              <div className="detail-price-card">
                <span className="price-label">Porsiyon Fiyatı</span>
                <span className="price-value">{product.portionPrice}</span>
              </div>
            )}

            {product.kgPrice && (
              <div className="detail-price-card highlight">
                <span className="price-label">Kilogram Fiyatı</span>
                <span className="price-value">{product.kgPrice}</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
